import axios from 'axios';
import { BaseUrl } from '../../server';

export const getAllBlogs = (page , limit,categoryId ,titleAr,titleEn,date) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_all_blogs_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/blogs`, {
            params: {
                page,
                limit,
                categoryId,
                titleAr,
                titleEn,
                date
            },
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_all_blogs_success',
            payload: {
                blogs: data.blogs,
                pagination: data.pagination,
                totalBlogs:data.totalBlogs // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_all_blogs_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};

export const getFillterBlogs = (page , limit,categoryId ,titleAr,titleEn,date) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_Fillter_blogs_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/blogs/filter`, {
            params: {
                page,
                limit,
                categoryId,
                titleAr,
                titleEn,
                date
            },
            withCredentials: true,
        } )
    ;

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_Fillter_blogs_success',
            payload: {
                blogs: data.blogs,
                pagination: data.pagination, // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_Fillter_blogs_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};
export const getBlog = (id) => async (dispatch) => {
    try {
       
        dispatch({ type: 'get_Blog_request' });

        const { data } = await axios.get(`${BaseUrl}/blogs/${id}`);
      
        dispatch({ type: 'get_Blog_success' ,payload:data.blog});

    } catch (error) {
        dispatch({
            type: "get_Blog_error",
            payload: error.response.data.message,
          });
    }
}
export const createBlog = (newForm) => async (dispatch) => {
    try {
        dispatch({ type: 'create_blog_request' });
        const config = { headers: { "Content-Type": "multipart/form-data" } };
        const { data } = await axios.post(`${BaseUrl}/blogs/create`,
           newForm,
           config);

        dispatch({ type: 'create_blog_success', payload: data.blog });
    } catch (error) {
        dispatch({
            type: "create_blog_error",
            payload: error.response.data.message,
          });
    }
};

export const deleteBlog = (id) => async (dispatch) => {
    try {
    
        dispatch({ type: 'delete_blog_request' });

     const {data} =  await axios.delete(`${BaseUrl}/blogs/${id}`);

        dispatch({ type: 'delete_blog_success' ,
    payload: data.message
    });
    } catch (error) {
        dispatch({
            type: "delete_blog_error",
            payload: error.response.data.message,
          });
    }
};
export const ClearBlog = () => async (dispatch) => {    
    dispatch({ type: 'clear_blog' });
}